import { useMemo } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { TValidationMethodConfig } from 'js/utils/Validation/types';
import { money, range, required } from 'js/utils/Validation/validationRules';

export const useValidationConfig = (
    { balance, amounts }: { balance: string; amounts: { fromAmount: number; toAmount: number }[] }
) => {
    const translate = useTranslations();

    return useMemo((): Record<string, TValidationMethodConfig[]> => ({
        amount: [
            required({ error: 'playtech.mobile.system.tooltip.required' }) as TValidationMethodConfig,
            money() as TValidationMethodConfig,
            range({
                min: 0,
                max: balance,
                error: 'playtech.mobile.system.user.tooltip.bonusMinAmount'
            }) as TValidationMethodConfig,
            ...amounts.map(({ fromAmount, toAmount }) => range({
                min: fromAmount,
                max: toAmount,
                error: `${translate('playtech.mobile.system.tooltip.buyInBetween')} ${fromAmount}-${toAmount}`
            }) as TValidationMethodConfig)
        ],
        terms: [
            required({
                predicate: (value: boolean) => value,
                error: 'playtech.mobile.system.user.tooltip.terms.required'
            }) as TValidationMethodConfig
        ]
    }), [translate, balance, amounts]);
};
